import { z } from "zod";
import { Button, Grid, TextInput } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "./components/ButtonMenu.js";
import { useForm, zodResolver } from "@mantine/form";
import diffFormData from "./utils/diffFormData.js";

// Validation schema
const schema = z.object({
  group_name: z
    .string({ message: "Name is required" })
    .min(1, { message: "Name is required" }),
  checklist_id: z.number().positive().min(1),
});

const DefaultQaChecklistGroupForm = ({
  defaultFormData = {},
  buttonProps = {},
  onSubmit,
  onCancel,
}) => {
  const form = useForm({
    mode: "uncontrolled",
    initialValues: defaultFormData,
    validate: zodResolver(schema),
  });

  const handleSubmit = async () => {
    const validateResult = form.validate();

    if (validateResult.hasErrors) {
      return;
    }

    const formData = form.getValues();

    const diffData = diffFormData(defaultFormData, formData);

    // call onSubmit with modeled data and diff data
    // diff data is used when the form is in edit context
    // diff may be used when we only want to update modified values
    onSubmit?.(formData, diffData);
  };

  const handleCancel = () => {
    form.reset();
    onCancel?.();
  };

  return (
    <>
      <Grid col={1} style={{ marginBottom: 10 }}>
        <TextInput
          size="sm"
          variant="outlined"
          label="Checklist Group Name"
          placeholder="Enter group name"
          required
          description={
            "This is the name of your checklist group. This will be used to identify the checklist group in the system."
          }
          key={form.key("group_name")}
          {...form.getInputProps("group_name")}
        />
      </Grid>
      <ButtonMenu>
        <Button size="xs" variant="subtle" onClick={handleCancel}>
          {buttonProps.cancelText || "Cancel"}
        </Button>
        <Button
          size="xs"
          color="primary"
          variant="contained"
          onClick={handleSubmit}
        >
          {buttonProps.submitText || "Submit"}
        </Button>
      </ButtonMenu>
    </>
  );
};

export default DefaultQaChecklistGroupForm;
